const Menu = [
    {header: "Main"},
    {
        title: "Statistics",
        icon: "dashboard",
        name: "Dashboard",
        permission: "STATS"
    },
    {
        title: "Requests",
        icon: "pin_drop",
        name: "Requests",
        permission: "DISPATCHING"
    },
    {
        title: "Timeline",
        icon: "schedule",
        name: "Timeline",
        permission: "DISPATCHING"
    },
    {
        title: "Monitoring",
        icon: "tv",
        items: [
            {
                title: "Map",
                name: "Map",
                permission: "MONITORING"
            },
            {
                title: "Monitor",
                name: "Monitor",
                permission: "MONITORING"
            },
            {
                title: "Lateness",
                name: "Lateness",
                permission: "LATENESS"
            },
            {
                title: "Notification Centre",
                name: "NotificationCentre",
                permission: "MONITORING"
            },
            {
                title: "Rides Tracker",
                name: "RidesTracker",
                permission: "MONITORING"

            },
            {
                title: "Path Drawer",
                name: "PathDrawer",
                permission: "MONITORING"
            },
            {
                title: "Rides Search",
                name: "RidesSearch",
                permission: "MONITORING"
            },
            {
                title: "AI Stats",
                name: "AiStats",
                permission: "AI_STATS"
            },
        ]
    },
    {
        title: "Operators",
        icon: "score",
        items: [
            {
                title: "Operator KPI",
                icon: "score",
                name: "OperatorKPI",
                permission: "VIEW_OPERATOR_KPI"
            },
            {
                title: "Users Schedule",
                icon: "calendar",
                name: "UserSchedule",
                permission: "USER_SCHEDULE"
            },
            {
                title: "Cancellation Table",
                icon: "score",
                name: "CancellationTable",
                permission: "VIEW_CANCELLATION_TABLE"
            }
        ],
    },
    {
        title: "Staff",
        icon: "group",
        items: [
            {
                title: "Users",
                name: "Users",
                permission: "USERS"
            },
            {
                title: "Roles",
                name: "Roles",
                permission: "ROLES"
            },
            {
                title: "Unresolved Leaves",
                name: "UnresolvedLeaves",
                permission: 'CAN_HANDLE_LEAVES'
            },
            {
                title: "Unresolved Extra Hours",
                name: "UnresolvedExtraHours",
                permission: 'CAN_HANDLE_EXTRA_HOURS'
            }
        ]
    },
    {
        title: "Passengers",
        icon: "people",
        items: [
            {
                title: "Unregistered",
                name: "UnregisteredPassengers",
                permission: "UNREGISTERED_PASSENGERS"
            },
            {
                title: "Registered",
                name: "Passengers",
                permission: "REGISTERED_PASSENGERS"
            }
        ]
    },
    {
        title: "Captains",
        icon: "people",
        items: [
            {
                title: "Unregistered",
                name: "UnregisteredCaptains",
                permission: "UNREGISTERED_CAPTAINS"
            },
            {
                title: "Registered",
                name: "Captains",
                permission: "REGISTERED_CAPTAINS"
            },
            {
                title: "New Car Requests",
                name: "CarRequests",
                permission: "NEW_CAR_REQUESTS"
            },
            {
                title: "Lost",
                name: "LostCaptains",
                permission: "LOST_CAPTAINS"
            },
            {
                title: "Weekly Present",
                name: "WeeklyPresentCaptains",
                permission: "WEEKLY_PRESENT_CAPTAIN"
            },
            {
                title: "Captain Cancellation Reasons",
                name: "CaptainCancellationReasons",
                permission: "CAPTAIN_CANCELLATION_REASONS"
            },
            {
                title: "Change Captain Reasons",
                name: "ChangeCaptainReasons",
                permission: 'CHANGE_CAPTAIN_REASONS'
            },
            {
                title: "Captain Performance",
                name: "CaptainPerformance",
                permission: "CAPTAIN_PERFORMANCE"
            },
            {
                title: "Captain Acceptance Ratio",
                name: "CaptainAcceptanceRatio",
                permission: "CAPTAIN_PERFORMANCE"
            },
            {
                title: "Accept/Reject Captains",
                name: "SuggestionAllowedCaptains",
                permission: "SUGGESTION_ALLOWED_CAPTAIN"
            }

        ]
    },
    {
        name: "Services",
        title: "Services",
        icon: "fa fa-bars",
        permission: "SERVICES"
    },
    {
        title: "Locations",
        icon: "map",
        items: [
            {
                name: "MapEditor",
                title: "Map Editor",
                permission: "LOCATIONS"
            },
            {
                name: "Locations",
                title: "Areas",
                permission: "LOCATIONS"
            },
            {
                name: "BlacklistLocations",
                title: "Blacklist Areas",
                permission: "LOCATIONS"
            },
            {
                name: "LocationContainers",
                title: "Containers",
                permission: "LOCATIONS"
            },
            {
                name: "Landmarks",
                title: "Landmarks",
                permission: "LOCATIONS"
            }
        ]
    },
    {
        title: "Types",
        icon: "select_all",
        items: [
            {
                title: "Colors",
                name: "Colors",
                permission: "TYPES"
            },
            {
                title: "Car Brands",
                name: "CarBrands",
                permission: "TYPES"
            },
            {
                title: "Nationalities",
                name: "Nationalities",
                permission: "TYPES"
            },
            {
                title: "Banks",
                name: "Banks",
                permission: "TYPES"
            }
        ]
    },
    {
        title: "Discounts",
        icon: "shopping_cart",
        items: [
            {
                title: "Vouchers",
                name: "Vouchers",
                permission: "VOUCHERS"
            },
            {
                title: "Phone Vouchers",
                name: "PhoneVouchers",
                permission: "VOUCHERS"
            },
            {
                title: "Demand Pump Monitor",
                name: "VoucherDemandPumpIndex",
                permission: "DEMAND_PUMP"
            },
            {
                title: "Demand Pump Creation",
                name: "VoucherDemandPumpCreate",
                permission: "DEMAND_PUMP"
            }
        ]
    },
    {
        title: "Captain Acquisition",
        icon: "schedule",
        items: [
            {
                title: "Available Times",
                name: "AvailableInterviewTimes",
                permission: "INTERVIEW_MANAGEMENT"
            },
            {
                title: "Interviews",
                name: "Interviews",
                permission: "INTERVIEW_MANAGEMENT"
            },
            {
                title: "Levels",
                name: "Level",
                permission: 'MANAGE_CONTRACT_TEMPLATES'
            },
            {
                title: "Contract Template",
                name: "contract_template",
                permission: 'MANAGE_CONTRACT_TEMPLATES'
            },
        ]
    },
    {
        title: "Accounting",
        icon: "attach_money",
        items: [
            {
                title: "New Accounting Page",
                name: "New Accounting Page",
                permission: "VIEW_PAYMENTS"
            },
            {
                title: "Captains payments",
                name: "Captains payments",
                permission: "VIEW_PAYMENTS"
            },
            {
                title: "Payments",
                name: "Payments",
                permission: "VIEW_PAYMENTS"
            },
            {
                title: "Cash Registers",
                name: "Cash Registers",
                permission: "CASH_REGISTER"
            },
            {
                title: "Pending C.R. Transactions",
                name: "Pending Transactions",
                permission: "CASH_REGISTER_MASTER"
            },
            {
                title: "Bonus Requests",
                name: "Bonus Requests",
                permission: "MANAGE_TRANSACTION"
            },
            {
                title: "Penalties & Bonuses",
                name: "Transactions",
                permission: "MANAGE_TRANSACTION"
            },
            {
                name: "Bonus Package",
                title: "Conditional Bonuses",
                permission: 'CONDITIONAL_BONUS'
            },
            {
                title: "Captain Balance",
                name: "Captain Balance",
                permission: "VIEW_PAYMENTS"
            },
        ]
    },
    {
        title: "HR",
        icon: "request_quote",
        permission: 'MANAGE_HR',
        items: [
            {
                title: "Employment types",
                name: "EmploymentTypes",
                permission: 'MANAGE_HR',
            },
            {
                title: "Salary reports",
                name: "SalariesReports",
                permission: 'SALARIES_MONITORING',
            },
            {
                title: "All Salaries reports",
                name: "AllSalariesReports",
                permission: 'SALARIES_MONITORING',
            },
            {
                title: "Salary events",
                name: "SalaryEvents",
                permission: 'CAN_ADD_SALARY_EVENTS',
            }
        ]
    },

    {
        title: "Customer Support",
        icon: "contact_support",
        items: [
            {
                title: "First Ride Pax",
                name: "FirstRidePax",
                permission: "FIRST_RIDE_PAX"
            },
            {
                title: "Rating Causes",
                name: "RatingCauses",
                permission: 'CUSTOMER_SUPPORT'
            },
            {
                title: "Tickets Management",
                name: "TicketsManagement",
                permission: 'TICKET_MANAGEMENT'
            },
            {
                title: "Tickets",
                name: "Tickets",
                permission: 'TICKETING'
            },
            {
                title: "Tickets Monitoring",
                name: "TicketsMonitoring",
                permission: 'OTHER_TICKETS'
            }
        ]
    },
    {
        title: "Qr Code",
        icon: "scanner",
        name: "GetQrCode",
        permission: "QR_CODE"
    },
    {
        title: "Marketing",
        icon: "campaign",
        items: [
            {
                title: "Advertising Campaign",
                name: "AdvertisingCampaign",
                permission: 'MANAGE_ADVERTISEMENTS'
            },
            {
                title: "Broadcast",
                name: "Broadcast",
                permission: "BROADCAST"
            },
        ]
    },
    {
        title: "Setting",
        icon: "settings",
        name: "Setting",
        permission: "SETTINGS"
    },
];

export default Menu;
